<template>
    <div class="app--engagement bg--body">
        <app-button v-if="!auth && loaded && sidebar && (page && page.type != 'FINISH')"
            class="app--engagement-sidebar-button" @click.native="open" icon="menu"></app-button>
        <engagement-header v-if="!auth && loaded"></engagement-header>
        <div class="app--engagement-content" v-if="!auth && loaded" :class="classes">
            <engagement-page v-for="p in pages" :key="p.id" :definition="p" :ref="p.id"
                v-show="page.id == p.id || print">
            </engagement-page>
        </div>
        <engagement-cfs-footer v-if="!auth && loaded" :pages="pages"></engagement-cfs-footer>
        <engagement-sidebar v-if="!auth && loaded" :pages="pages"></engagement-sidebar>
        <engagement-auth v-if="auth" :pages="pages"></engagement-auth>
        <engagement-loader v-if="!loaded"></engagement-loader>
        <engagement-oops v-if="error || iError"></engagement-oops>
    </div>
</template>

<script>
import store from './store'
import { v4 as uuid } from 'uuid'
import Header from './components/Header'
import Page from './components/Page'
import Sidebar from './components/Sidebar'
import Auth from './components/Auth'
import Icon from './../components/Icon'
import Button from './../components/Button'
import Loader from './../components/Loader'
import Oops from './components/helpers/Oops'
import CfsFooter from './components/helpers/CfsFooter'

export default {
    computed: {
        session() { return store.state.session },
        pages() { return store.state.template.panels.filter(p => store.getters['visiblePanel'](p)) },
        page() { return store.state.page },
        auth() { return store.state.auth.active },
        print() { return store.state.printing },
        edit() { return store.state.auth.authenticated === true && store.state.complete !== true },
        sidebar() { return store.state.theme.sidebar.enabled && store.state.auth.authenticated === true },
        iError() { return store.state.error },
        classes() {
            return {
                'fixed-header': store.state.theme.header.enabled && store.state.theme.header.fixed,
                'fixed-footer': store.state.theme.footer.fixed,
                'has-header': store.state.theme.header.enabled,
                'has-sidebar': this.sidebar,
            }
        },
        state() {
            return store.state.elements.find(e => {
                return e.definition == store.getters['customElement']('college_state').id
            })
        },
        college() {
            return store.getters['customElement']('college_cbc')
        }
    },
    watch: {
        session: {
            deep: true,
            immediate: true,
            handler(value) {
                if (this.session && this.session.hasOwnProperty('pfp_session') && window.axios) {
                    window.axios.defaults.headers.common['X-PFP-SESSION'] = this.session.pfp_session
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = this.session.csrf_token
                }
            }
        },
        panel: {
            deep: true,
            immediate: true,
            handler(value, previous) {
                if (value && value.id) {
                    window.analytics.enter(value.id)
                    store.dispatch('analytics', { action: 'enter', id: value.id })
                }
                if (previous && previous.id) {
                    window.analytics.leave(
                        store.state.id,
                        store.state.template.id,
                        store.state.template.title,
                        previous.id,
                        previous.title
                    )
                    store.dispatch('analytics', { action: 'leave', id: previous.id })
                }
            }
        },
        state: {
            deep: true,
            immediate: true,
            handler(element) {
                if (this.loading.colleges == false) {
                    if (element && element.value && element.value.state && this.college) {
                        this.loading.colleges = true
                        axios.post('/e/cfs/colleges', { state: element.value.state }).then(response => {
                            this.loading.colleges = false
                            let college = this.college
                            college.options.structure.groups[0].items = response.data
                            store.commit('SET_TEMPLATE_ELEMENT', college)
                        })
                    }
                    if (element && element.id && element.value == null) {
                        element.value = { address1: '', address2: '', city: '', zip: '', state: '', country: 'US' }
                        store.commit('ADD_ELEMENT', element)
                    }
                }
            }
        },
        'loading.colleges': function (value) {
            if (value == true) {
                document.querySelector('.custom-college_cbc').querySelector('select.form-control').setAttribute('disabled', true);
            }
            if (value == false) {
                document.querySelector('.custom-college_cbc').querySelector('select.form-control').setAttribute('disabled', false);
                let el = store.state.elements.find(e => e.definition == this.college.id)
                if (el && el.value) {
                    this.$nextTick(() => {
                        document.querySelector('.custom-college_cbc').querySelector('select.form-control').value = el.value
                    })
                }
            }
        }
    },
    data() {
        return { loaded: false, working: false, error: false, loading: { colleges: false } }
    },
    created() {
        window.addEventListener('beforeunload', event => {
            if (this.page) {
                store.dispatch('analytics', { action: 'unload', id: this.page.id })
            }
            if (store.state.queue.filter(e => e._default !== true).length > 0) {
                if (store.state.security == 'LOW' && store.state.auth.authenticated == false) {
                    store.dispatch('create')
                } else {
                    store.dispatch('save')
                }
                event.returnValue = this.$t('app.confirm.dirty')
                return this.$t('app.confirm.dirty')
            }
        })
        window.addEventListener('unload', event => {
            if (this.page) {
                window.analytics.leave(
                    store.state.id,
                    store.state.template.id,
                    store.state.template.title,
                    this.page.id,
                    this.page.title
                )
            }
        })

        if (store.state.security == 'LOW') {
            let member = store.state.members.find(m => m.active == true)
            if (member && member.name && member.security == 'LOW') {
                this.working = true
                store.dispatch('create').then((response) => { this.loaded = true; this.working = false })
            } else {
                let account = { type: 'ACCOUNT', id: uuid() }
                let client = { type: 'CLIENT', id: uuid() }
                let group = { id: uuid() }
                store.commit('ADD_MEMBER', { type: 'CLIENT', name: 'Anonymous', active: true, coclient: false })
                store.commit('ADD_PANEL', client)
                store.commit('ADD_PANEL', account)
                store.commit('ADD_GROUP', group)
                store.state.template.elements.forEach(e => {
                    let type = store.state.template.panels.find(
                        p => p.id == store.state.template.groups.find(g => g.id == e.group).panel
                    ).type
                    store.commit('ADD_ELEMENT', {
                        id: uuid(),
                        panel: type == 'ACCOUNT' ? account.id : client.id,
                        group: group.id,
                        definition: e.id,
                        value: null
                    })
                })
                this.loaded = true
            }
        } else {
            this.loaded = true
        }
    },
    mounted() {
        this.save()
    },
    methods: {
        open() {
            store.commit('SET_SIDEBAR', true)
        },
        save() {
            if (!this.working && store.state.queue.length > 0) {
                this.working = true
                if (store.state.security == 'LOW' && store.state.auth.authenticated == false) {
                    store.dispatch('create').then((response) => {
                        if (response === false) {
                            this.error = true
                        } else {
                            this.working = false
                        }
                    })
                } else {
                    store.dispatch('save').then((response) => {
                        if (response === false) {
                            this.error = true
                        } else {
                            this.working = false
                        }
                    })
                }
            }
            setTimeout(() => { this.save() }, 1000);
        }
    },
    components: {
        'engagement-header': Header,
        'engagement-page': Page,
        'engagement-sidebar': Sidebar,
        'engagement-cfs-footer': CfsFooter,
        'engagement-auth': Auth,
        'app-icon': Icon,
        'app-button': Button,
        'engagement-loader': Loader,
        'engagement-oops': Oops
    }
}
</script>
